<template>
    <div>
        <div class="search-wrapper shadow-radius">
            <input type="text"
                   placeholder="جست‌و‌جو در نتایج"
                   id="prolist-search"
                   v-model="searchExpr"
                   @keyup.enter="searchExprChange" />
            <span class="avafont-magnify" @click="searchExprChange"></span>
        </div>
        <div class="shadow-radius filtersList"
             v-if="(value.name && value.name.length) ||
                    value.isAvailable ||
                    (value.minPrice && value.maxPrice) ||
                    (selectedBrands && selectedBrands.length) ||
                    (selectedColors && selectedColors.length)">
            <div class="d-flex w-100 justify-content-between top-row">
                <h6 class="ttl">فیلترها</h6>
                <button type="button" class="red-radius-btn" @click="clearFilters">
                    پاک کردن همه
                </button>
            </div>
            <ul>
                <li v-if="value.name && value.name.length" key="searchExpr">
                    {{ value.name }}
                    <span class="avafont-close" @click="clearSearchExpr"></span>
                </li>
                <li v-if="value.isAvailable" key="isAvailable">
                    محصولات موجود
                    <span class="avafont-close" @click="clearIsAvailable"></span>
                </li>
                <li v-if="value.minPrice && value.maxPrice" key="prices">
                    {{ (value.minPrice/ 10).toLocaleString() | toPersianNumber }}تا - {{ (value.maxPrice/ 10).toLocaleString() | toPersianNumber }}تومان
                    <span class="avafont-close" @click="clearPrices"></span>
                </li>
                <li v-for="brand in selectedBrands" :key="'brand' + brand.id">
                    {{ brand.persianName }}
                    <span class="avafont-close" @click="removeBrand(brand.id)"></span>
                </li>
                <li v-for="color in selectedColors" :key="'color' + color.id">
                    {{ color.name }}
                    <span class="avafont-close" @click="removeColor(color.id)"></span>
                </li>
            </ul>
        </div>
        <div class="shadow-radius filters">
            <div class="row">
                <div class="col-12">
                    <div class="show-available filter-box">
                        <div class="button_toggle">
                            <h6 class="ttl">فقط محصولات موجود</h6>
                            <button type="button"
                                    class="btn btn-toggle"
                                    :class="{ active: value.isAvailable }"
                                    :aria-pressed="value.isAvailable"
                                    @click="availabilityChanged()">
                                <div class="handle"></div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="row">
                <div class="col-12">
                    <div class="avajang-guarantee filter-box">
                        <div class="button_toggle">
                            <h6 class="ttl">فقط گارانتی آواژنگ</h6>
                            <button type="button" class="btn btn-toggle" data-toggle="button">
                                <div class="handle"></div>
                            </button>
                        </div>
                    </div>
                </div>
            </div> -->
            <div class="row" v-if="data.minPrice != null && data.maxPrice != null && data.minPrice != data.maxPrice">
                <div class="col-12">
                    <div class="brand-filter filter-box p-15">
                        <b-button v-b-toggle.collapse-0 class="accordion-ttl">
                            <span>
                                بازه قیمت محصولات
                            </span>
                            <i class="avafont-arrow-up when-opened"></i>
                            <i class="avafont-arrow-down when-closed"></i>
                        </b-button>
                        <b-collapse visible id="collapse-0">
                            <vue-slider v-model="priceRange"
                                        :min="data.minPrice"
                                        :max="data.maxPrice"
                                        :enableCross="false"
                                        :tooltip-formatter="(val) => toPersianCurrency(val)"
                                        @drag-end="priceChange"></vue-slider>
                        </b-collapse>
                        <div class="price-range">
                            <label>
                                حداقل قیمت از:
                            </label>
                            <div class="border-radius" v-if="value.minPrice">
                                {{ (value.minPrice / 10).toLocaleString() | toPersianNumber }}تومان
                            </div>
                            <div class="border-radius" v-else>
                                {{ (data.minPrice / 10).toLocaleString() | toPersianNumber }}تومان
                            </div>
                            <label>
                                تا حداکثر قیمت:
                            </label>
                            <div class="border-radius" v-if="value.maxPrice">
                                {{ (value.maxPrice / 10).toLocaleString() | toPersianNumber }}تومان
                            </div>
                            <div class="border-radius" v-else>
                                {{ (data.maxPrice / 10).toLocaleString() | toPersianNumber }}تومان
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="brand-filter filter-box p-15">
                        <b-button v-b-toggle.collapse-1 class="accordion-ttl">
                            <span>
                                انتخاب برند
                            </span>
                            <i class="avafont-arrow-up when-opened"></i>
                            <i class="avafont-arrow-down when-closed"></i>
                        </b-button>
                        <b-collapse visible id="collapse-1" v-if="data.brands">
                            <div class="filter-search">
                                <input type="text"
                                       placeholder="جست‌و‌جوی برند..."
                                       class="search"
                                       v-model="searchBrand" />
                                <i class="avafont-magnify"></i>
                            </div>
                            <div class="opt" v-for="brand in presentableBrands" :key="brand.id">
                                <input type="checkbox"
                                       class="custom-input-button"
                                       v-model="selectedBrandIds"
                                       :id="'brand' + brand.id"
                                       :value="brand.id" />
                                <label :for="'brand' + brand.id">
                                    <span class="fa">{{ brand.persianName }}</span>
                                </label>
                                <!--<label :for="'brand' + brand.id">
                                    <span class="en">{{ brand.name }}</span>
                                </label>-->
                            </div>
                            <button class="view-more-less"
                                    v-if="filteredBrands.length > countOfFiltersInLessMode"
                                    @click="showLessBrands = !showLessBrands">
                                {{ showLessBrands ? 'برندهای بیشتر...' : 'برندهای کمتر...' }}
                            </button>
                        </b-collapse>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="color-filter filter-box p-15">
                        <b-button v-b-toggle.collapse-2 class="accordion-ttl">
                            <span>
                                انتخاب رنگ‌
                            </span>
                            <i class="avafont-arrow-up when-opened"></i>
                            <i class="avafont-arrow-down when-closed"></i>
                        </b-button>
                        <b-collapse visible id="collapse-2" v-if="data.colors">
                            <div class="filter-search">
                                <input type="text"
                                       placeholder="جست‌و‌جوی رنگ..."
                                       class="search"
                                       v-model="searchColor" />
                                <i class="avafont-magnify"></i>
                            </div>
                            <div class="opt" v-for="color in presentableColors" :key="color.id">
                                <input type="checkbox"
                                       class="custom-input-button"
                                       v-model="selectedColorIds"
                                       :id="'color' + color.id"
                                       :value="color.id" />
                                <label :for="'color' + color.id">
                                    <span class="name">{{ color.name }}</span>
                                </label>
                                <label :for="'color' + color.id">
                                    <span class="code" :style="{'background-color':color.code}"></span>
                                </label>
                            </div>
                            <button class="view-more-less"
                                    v-if="filteredColors.length > countOfFiltersInLessMode"
                                    @click="showLessColors = !showLessColors">
                                {{ showLessColors ? 'رنگ های بیشتر...' : 'رنگ های کمتر...' }}
                            </button>
                        </b-collapse>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { PRODUCT_LIST_CONSTANTS } from '@/constants/constants';
    import VueSlider from 'vue-slider-component';
    import 'vue-slider-component/theme/default.css';
    import Utils from '@/utilities/utils';

    export default {
        name: 'Aside',
        components: { VueSlider },
        props: {
            value: {
                type: Object,
                default: {
                    colors: [],
                    brands: [],
                    minPrice: 0
                }
            },
            data: Object
        },
        data() {
            return {
                searchBrand: '',
                searchColor: '',
                selectedBrandIds: [],
                selectedColorIds: [],
                showLessBrands: true,
                showLessColors: true,
                priceRange: null,
                searchExpr: undefined
            };
        },
        computed: {
            countOfFiltersInLessMode: () => PRODUCT_LIST_CONSTANTS.countOfFiltersInLessMode,
            filteredBrands() {
                if (!this.data.brands) return [];

                return this.data.brands.filter((brand) => {
                    return brand.persianName.toLowerCase().includes(this.searchBrand.toLowerCase());
                });
            },
            presentableBrands() {
                return this.showLessBrands
                    ? this.filteredBrands.slice(0, PRODUCT_LIST_CONSTANTS.countOfFiltersInLessMode)
                    : this.filteredBrands;
            },
            filteredColors() {
                if (!this.data.colors) return [];

                return this.data.colors.filter((color) => {
                    return color.name.toLowerCase().includes(this.searchColor.toLowerCase());
                });
            },
            presentableColors() {
                return this.showLessColors
                    ? this.filteredColors.slice(0, PRODUCT_LIST_CONSTANTS.countOfFiltersInLessMode)
                    : this.filteredColors;
            },
            selectedBrands() {
                return (this.selectedBrandIds || []).map((id) => this.data.brands.find((brand) => brand.id == id));
            },
            selectedColors() {
                return (this.selectedColorIds || []).map((id) => this.data.colors.find((color) => color.id == id));
            }
        },
        beforeMount() {
            this.load();
        },
        methods: {
            load() {
                this.searchExpr = this.value.name;
                this.selectedBrandIds = this.value.brands || [];
                this.selectedColorIds = this.value.colors || [];
                this.priceRange = [
                    this.value.minPrice || this.data.minPrice,
                    this.value.maxPrice || this.data.maxPrice
                ];
            },
            searchExprChange() {
                this.$emit('input', {
                    ...this.value,
                    name: this.searchExpr == '' ? undefined : this.searchExpr
                });
            },
            availabilityChanged() {
                this.$emit('input', {
                    ...this.value,
                    isAvailable: !this.value.isAvailable ? true : undefined
                });
            },
            priceChange() {
                var minPrice = this.priceRange[0];
                var maxPrice = this.priceRange[1];

                if (minPrice === this.data.minPrice && maxPrice === this.data.maxPrice) {
                    minPrice = undefined;
                    maxPrice = undefined;
                }

                this.$emit('input', {
                    ...this.value,
                    minPrice: minPrice,
                    maxPrice: maxPrice
                });
            },
            clearFilters() {
                this.$emit('input', {});
            },
            clearSearchExpr() {
                this.$emit('input', {
                    ...this.value,
                    name: undefined
                });
            },
            clearIsAvailable() {
                this.$emit('input', {
                    ...this.value,
                    isAvailable: undefined
                });
            },
            clearPrices() {
                this.$emit('input', {
                    ...this.value,
                    minPrice: undefined,
                    maxPrice: undefined
                });
            },
            removeBrand(brandId) {
                if (!this.value.brands) return;

                this.value.brands.splice(this.value.brands.indexOf(brandId), 1);
                this.$emit('input', {
                    ...this.value,
                    brands: this.value.brands.length ? this.value.brands : undefined
                });
            },
            removeColor(colorId) {
                if (!this.value.colors) return;

                this.value.colors.splice(this.value.colors.indexOf(colorId), 1);
                this.$emit('input', {
                    ...this.value,
                    colors: this.value.colors.length ? this.value.colors : undefined
                });
            },
            toPersianCurrency(value) {
                return Utils.toPersianCurrency(value/10);
            }
        },
        watch: {
            selectedBrandIds: {
                handler(value) {
                    // avoid duplicate push url
                    if ((!this.value.brands || !this.value.brands.length) && (!value || !value.length)) return;

                    this.$emit('input', {
                        ...this.value,
                        brands: value
                    });
                },
                deep: true
            },
            selectedColorIds: {
                handler(value) {
                    // avoid duplicate push url
                    if ((!this.value.colors || !this.value.colors.length) && (!value || !value.length)) return;

                    this.$emit('input', {
                        ...this.value,
                        colors: value
                    });
                },
                deep: true
            },
            value: {
                handler(val) {
                    this.$emit('onChangeFilters', val);
                    this.load();
                },
                deep: true
            }
        }
    };
</script>
